import PropTypes from 'prop-types'
import { useTranslation, Trans } from 'react-i18next'
import InfoModal from '../../../common/InfoModal'

import { ReactComponent as WarningIcon } from '../../../../assets/images/common/icons/warning-icon.svg'
import colors from '../../../../assets/styles/globals.scss'

const DefaultBodyText = () => {
  const { t } = useTranslation()

  return (
    <>
      <p>
        <Trans i18nKey='communitySettings.pricing.deleteModal.defaultIntro' components={{ b: <b /> }} />
      </p>
      <p>
        {t('communitySettings.pricing.deleteModal.defaultDeleteRemoves')}
      </p>
      <p style={{ color: colors.red }}>
        <strong>{t('communitySettings.common.actionPermanent')}</strong>
      </p>
    </>
  )
}

const SingleWithinProgramBodyText = () => {
  const { t } = useTranslation()

  return (
    <>
      <p>
        <Trans i18nKey='communitySettings.pricing.deleteModal.singleIntro' components={{ b: <b /> }} />
      </p>
      <p>
        <b>{t('communitySettings.pricing.deleteModal.ifDelete')}</b>
        <ul>
          <li>{t('communitySettings.pricing.switchToOfflinePayments')}</li>
          <li>{t('communitySettings.pricing.onlinePaymentsDisabledUntilNew')}</li>
        </ul>
      </p>
      <p>{t('communitySettings.pricing.programsNeedActivePackage')}</p>
      <p style={{ color: colors.red }}>
        <strong>{t('communitySettings.common.actionPermanent')}</strong>
      </p>
    </>
  )
}

const DeletePackageConfirmationModal = ({ isSingleWithinProgram, ...props }) => {
  const { t } = useTranslation()

  return (
    <InfoModal
      title={t('communitySettings.pricing.deleteModal.title')}
      icon={<WarningIcon />}
      buttonMessage={t('common.delete')}
      {...props}
    >
      <div className='mx-4 text-left'>
        {isSingleWithinProgram ? <SingleWithinProgramBodyText /> : <DefaultBodyText />}
      </div>
    </InfoModal>
  )
}

DeletePackageConfirmationModal.propTypes = {
  isSingleWithinProgram: PropTypes.bool,
}

export default DeletePackageConfirmationModal
